import { render, staticRenderFns } from "./NfcInfoDialog.vue?vue&type=template&id=637b203f&scoped=true&"
import script from "./NfcInfoDialog.vue?vue&type=script&lang=js&"
export * from "./NfcInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./NfcInfoDialog.vue?vue&type=style&index=0&id=637b203f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637b203f",
  null
  
)

export default component.exports